import { Button, HStack, Stack } from "@chakra-ui/react";
import React, { useRef } from "react";
import { observer } from "mobx-react";
import { toBlob } from "html-to-image";
import { AppLink } from "@/routing/AppLink";
import { TrainingCertificate } from "./TrainingCertificate";
import { useStore } from "@/store";
import { saveAs } from "@/helpers/download";
import { translations } from "@/constants/translations";
import { telemetry } from "@/telemetry";

export const TrainingCertificatePage = observer(() => {
  const certificateNodeRef = useRef<HTMLDivElement>(null);
  const { trainingData, activeLanguage } = useStore();
  const language = translations.pages["training"][activeLanguage];

  const handleDownload = () => {
    if (!certificateNodeRef.current) return;
    const elapsed = telemetry.startTimer();
    toBlob(certificateNodeRef.current, {
      canvasWidth: 1054,
      canvasHeight: 814,
    })
      .then((blob) => {
        saveAs(blob, "Certificate-of-Completion.png");
        telemetry.trackEvent("certificate_downloaded", {
          result: "ok",
          render_duration_ms: elapsed(),
        });
      })
      .catch((error) => {
        telemetry.trackEvent("certificate_downloaded", {
          result: "error",
          render_duration_ms: elapsed(),
        });
        throw error;
      });
  };

  return (
    <Stack spacing="14">
      <TrainingCertificate
        ref={certificateNodeRef}
        traineeName={trainingData.name}
      />
      <HStack
        justifyContent="space-between"
        flexDirection={{ base: "column", sm: "row" }}
      >
        <AppLink to="/">
          <Button>{language.return_to}</Button>
        </AppLink>
        <Button onClick={handleDownload}>{language.download_button}</Button>
      </HStack>
    </Stack>
  );
});
